module.exports = __webpack_public_path__ + "static/media/3pl3.2fb2a917.png";